import { Controller } from "@hotwired/stimulus"

// Exclusión entre las dos caras del período (V2::PeriodFieldComponent): el
// rango rápido (select) o el intervalo absoluto (fecha + hora, Desde/Hasta),
// como el selector de tiempo de Grafana. Con una fecha escrita el rango
// rápido no se está usando: se esconde y se deshabilita (no viaja en el GET,
// así el servidor ni lo ve). Al elegir un rango rápido, las fechas y horas se
// vacían. Sin fechas, el rango vuelve y las horas se vacían también: una hora
// sin su fecha no significa nada (V2::PeriodFilter la ignora).
//
// Escucha `change` en el campo entero: lo disparan los inputs nativos al
// tipear y también `v2--date-range` al escribir desde el calendario.
export default class extends Controller {
  static targets = ["quick", "quickSelect", "date", "time", "clear"]

  connect() {
    this.sync()
  }

  sync() {
    const absolute = this.dateTargets.some((input) => input.value !== "")

    if (!absolute) for (const input of this.timeTargets) input.value = ""
    if (this.hasQuickTarget) {
      this.quickTarget.hidden = absolute
      this.quickSelectTarget.disabled = absolute
    }
    if (this.hasClearTarget) this.clearTarget.hidden = !absolute
  }

  // Un rango rápido recién elegido reemplaza al intervalo absoluto.
  pickQuick() {
    if (this.quickSelectTarget.value === "") return

    this.reset()
  }

  clear() {
    this.reset()
    if (this.hasQuickSelectTarget) this.quickSelectTarget.focus()
  }

  reset() {
    for (const input of [...this.dateTargets, ...this.timeTargets]) input.value = ""
    // `change` en las fechas: el calendario y `sync` (vía el campo) lo escuchan.
    for (const input of this.dateTargets) {
      input.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
